import { render, staticRenderFns } from "./setterMetro.vue?vue&type=template&id=41986447&scoped=true&"
import script from "./setterMetro.vue?vue&type=script&lang=js&"
export * from "./setterMetro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41986447",
  null
  
)

export default component.exports